"use strict"
const isEmpty = require("lodash/isEmpty");
const lodashMerge = require("lodash/merge");
const $ = require("jquery");

let cachedQueryParam = null;
let initialised = false;

const getCookie = cname => {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};
function param(targetKey) {
    if (isEmpty(targetKey)) {
        return;
    }

    targetKey = targetKey.toLowerCase();

    if (cachedQueryParam === null) {
        cachedQueryParam = {};

        let query = window.location.search.substring(1);

        const idx = query.indexOf("#");
        if (idx != -1) {
            query = query.substring(0, idx);
        }

        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");

            if (isEmpty(pair[0])) {
                continue;
            }

            const key = pair[0].toLowerCase();
            let value = "";
            if (!isEmpty(pair[1])) {
                value = pair[1].replace(/\+/g, " ");
                value = decodeURIComponent(value);
            }

            cachedQueryParam[key] = value;
        }

        lodashMerge(cachedQueryParam, window.__REQPARAM__);
    }

    const targetValue = cachedQueryParam[targetKey];

    return targetValue;
}

const defaultPostcode = getDefaultPostcode();
const defaultState = getStateFromPostcode(defaultPostcode);
const postcodeStateMap = {
            "2600": "ACT",
            "2000": "NSW",
            "4000": "QLD",
            "5000": "SA",
            "3000": "VIC",
            "6000": "WA",
            "7000": "TAS",
            "0800": "NT",
            "0900": "NT"
        };
const PostcodeGhost = {
            log: log,
            setPostcode: setPostcode,
            setState: setState,
            isValidPostcode: isValidPostcode,
            getStateFromPostcode: getStateFromPostcode,
            isOfState: isOfState,
            getPostcodeFromState: getPostcodeFromState,
            isPostcodePOBox: isPostcodePOBox,
            postcodeNotServiced: postcodeNotServiced,
            get state() {
                if (!initialised) {
                    init();
                }
                return state;
            },
            set state(state){
                setState(state);
            },
            STATES: isState(),
            get postcode() {
                if (!initialised) {
                    init();
                }
                return postcode;
            },
            set postcode(code) {
                setPostcode(code);
            }
        };
const australianState = ["ACT", "NSW", "VIC", "SA", "QLD", "TAS", "NT", "WA"];
let postcode = defaultPostcode;
let state = defaultState;
function init() {
            initialised = true;
            let geoIpPostcode;
            if(typeof(PostcodeGhostOptions) !== "undefined"){
                if(PostcodeGhostOptions.useGeoIpDetection === true){
                    geoIpPostcode = PostcodeGhostOptions.geoIpPostcode;
                }
            }
            const drupalStateCookie = getCookie("state");
            const drupalStateCookieDetected = getCookie("stateDetected");
            const pgPostcode = window.localStorage.getItem("postcode");

            if (param('postcode')) { // get postcode from params?
                const postcodeParams = param('postcode');
                setPostcode(postcodeParams);
                PostcodeGhost.postcodeIsDefault = false;
            } else if (pgPostcode) { // postcode in localStorage?
                setPostcode(pgPostcode);
                PostcodeGhost.postcodeIsDefault = false;
            } else if (drupalStateCookie) { // get postcode from drupal state cookie
                setPostcode(getPostcodeFromState(drupalStateCookie));
                PostcodeGhost.postcodeIsDefault = false;
            } else if (typeof(geoIpPostcode) !== "undefined") { // geo ip postcode detected by drupal?
                    setPostcode(geoIpPostcode);
            } else {
                setPostcode(defaultPostcode);
                console.log("defaultPostcode");
                PostcodeGhost.postcodeIsDefault = true;
            }
        }

function getDefaultPostcode() {
            if (typeof(PostcodeGhostOptions) !== "undefined") {
                    return PostcodeGhostOptions.defaultPostcode;
            }
            return "2000";
        }

function log() {
            console.log("postcode: ", PostcodeGhost.postcode);
            console.log("state: ", PostcodeGhost.state);
            console.log("drupalStateCookie: ", getCookie("state"));
            console.log("drupalStateCookieDetected: ", getCookie("stateDetected"));
            console.log("analytics cookie: ", getAnalyticsPostcode());
            console.log("PostcodeGhost cookie: ", localStorage.getItem("postcode"));
        }

function setAnalyticsState(postCode) {
  try {
    const userProfile = JSON.parse(localStorage.getItem('digitalData')) || {};
    userProfile['state'] = getStateFromPostcode(postCode);
    localStorage.setItem('digitalData', JSON.stringify(userProfile));
  } catch(e) {}
}

function setAnalyticsPostcode(postCode) {
  try {
    const userProfile = JSON.parse(localStorage.getItem('digitalData')) || {};
    userProfile['postCode'] = postCode;
    localStorage.setItem('digitalData', JSON.stringify(userProfile));
    setAnalyticsState(postCode);
  } catch(e) {}
}

function getAnalyticsPostcode() {
  try {
    let postCode;
    const digitalData = JSON.parse(localStorage.getItem('digitalData'));
    postCode = digitalData.postCode;
    return postCode;
  } catch(e) {}
}

function setPostcode(newPostcode) {
    newPostcode = "" + newPostcode;
    if(newPostcode !== postcode){
        if (isValidPostcode(newPostcode)) {
            postcode = "" + newPostcode;
            state = getStateFromPostcode(postcode);
            setAnalyticsPostcode(postcode);
            localStorage.setItem("postcode", postcode);
            console.log('trigger postcode update to: ', postcode);
            $(document).trigger("location:update", [state, postcode]);
            return true;
        }
        return false;
    }
}

function setState(newPostcodeState) {
            let newState;
            if(newPostcodeState){
                newState = newPostcodeState.toUpperCase();
            }
            setPostcode(getPostcodeFromState(newState));
        }

function isValidPostcode(postcode, includePOBox) {
            const REGEX_POSTCODE = /^[0-9]{4}$/i;
            const postcodeValid = parseInt(postcode);

            if (isNaN(postcodeValid)) {
                return false;
            }

            if (REGEX_POSTCODE.test(postcodeValid) === false) {
                return false;
            }

            if (postcodeValid < 1000 || postcodeValid > 9999) {
                if (isPostcodePOBox(postcodeValid) === false) {
                    return false;
                }
            }

            if (!includePOBox && isPostcodePOBox(postcodeValid)) {
                return false;
            }

            if (includePOBox === "undefined") {
                if (isPostcodePOBox(postcode)) {
                    return false;
                }
            }

            return true;
        }

function getStateFromPostcode(postcodeString) {
            const postcode = parseInt(postcodeString);
            if (isNaN(postcode)) {
                return "NSW";
            }
            if(!isValidPostcode(postcode)){
                return "NSW";
            }
            if (3000 <= postcode && postcode <= 3999) {
                return "VIC";
            } else if (4000 <= postcode && postcode <= 4999) {
                return "QLD";
            } else if (5000 <= postcode && postcode <= 5999) {
                return "SA";
            } else if (6000 <= postcode && postcode <= 6999) {
                return "WA";
            } else if (7000 <= postcode && postcode <= 7999) {
                return "TAS";
            } else if ((2600 <= postcode && postcode <= 2618) || (2900 <= postcode && postcode <= 2920)) {
                return "ACT";
            } else if (800 <= postcode && postcode <= 999) {
                return "NT";
            }
            return "NSW";
        }

function isOfState(postcode, targetState) {
            if(isValidPostcode(postcode) && targetState){
                let target = targetState.toUpperCase();
                if(australianState.indexOf(target)>=0){
                    return getStateFromPostcode(postcode) == target;
                }
            }
            return false;
        }

function getPostcodeFromState(state = "") {
  if(state){
    state = state.toUpperCase();
    switch (state) {
      case "NSW":
      return "2000"
      case "VIC":
      return "3000";
      case "QLD":
      return "4000";
      case "SA":
      return "5000";
      case "ACT":
      return "2600";
      case "WA":
      return "6000";
      case "TAS":
      return "7000";
      case "NT":
      return "0800";
      default:
      return "2000";
    }
  }
  return "2000";
}

function isPostcodePOBox(postBox) {
    const poBox = parseInt(postBox);
    if (
        (200 <= poBox && poBox <= 299) ||
        (900 <= poBox && poBox <= 1999) ||
        (5800 <= poBox && poBox <= 5999) ||
        (6800 <= poBox && poBox <= 6999) ||
        (7800 <= poBox && poBox <= 9999 ||
        poBox == 5071)
    ) {
        return true;
    }
    return false;
}

function isState(){
  return {
    ACT: "ACT",
    WA: "WA",
    SA: "SA",
    NSW: "NSW",
    VIC: "VIC",
    TAS: "TAS",
    QLD: "QLD",
    NT: "NT"
  }
}

function postcodeNotServiced(postcodeString) {
    const postcode = parseInt(postcodeString);
    if (isNaN(postcode)) {
        return true;
    }

    if (postcode >= 6000 && postcode < 7000) {
        return true;
    }

    if (postcode >= 7000 && postcode < 8000) {
        return true;
    }

    if (postcode >= 800 && postcode < 1000) {
        return true;
    }

    if (isPostcodePOBox(postcode)) {
        return true;
    }
    return false;
}

//  -----improvements------------------
// GOOGLE_API_GEOCODE: "https://maps.googleapis.com/maps/api/geocode/json",
// curl http://v0.postcodeapi.com.au/suburbs/3066.json -H 'Accept: application/json; indent=4'
        // function getPostcodeFromLatLong(latitude, longitude) {
        //     const params = {
        //         latlng: latitude + "," + longitude
        //     };
        //     return get("GOOGLE_API_GEOCODE", params).then(function(data) {
        //         const addrCompLength = _.get(data, "results[0].address_components.length", null);
        //         if (addrCompLength) {
        //             const postcode = _.get(
        //                 data,
        //                 "results[0].address_components[" + (addrCompLength - 1) + "].long_name",
        //                 "0"
        //             );
        //             return postcode;
        //         }
        //         return -1;
        //     });
        // }
        // function searchPostcodeBySuburb(option) {
        //     const query = option.query;
        //     const includePOBox = option.includePOBox;
        //     const maxCount = option.maxCount;
        //     let ret = get("SEARCH_POSTCODE", { suburbSearchKey: query });
        //     if (!includePOBox) {
        //         ret = ret.then(function(data) {
        //             return _.filter(data, function(d) {
        //                 return d.type === "DELIVERY";
        //             });
        //         });
        //     }
        //     if (maxCount > 0) {
        //         ret = ret.then(function(data) {
        //             return _.take(data, maxCount);
        //         });
        //     }
        //     return ret;
        // }
        // function postcodeTypeahead(type: string) {
        //     return searchPostcodeBySuburb({
        //         query: type,
        //         includePOBox: false,
        //         maxCount: 10
        //     });
        // }

// ---------------------------------------------


        module.exports = PostcodeGhost;
